import { useMemo } from 'react';

import { Edge } from 'react-native-safe-area-context';

function useSafeAreaEdges(): Edge[] {
    return useMemo(() => ['left', 'right'], []);
}

export default useSafeAreaEdges;
